import type { TenderCaseListItemApi } from "@/api/tender-api"

/**
 * A case is "handed off" once the preparer has handed it over to the new owner
 * (the Ansvarig). `handedOffAt` is null while the case is still being prepared.
 *
 * Drives the landing-page handoff-state filter (In preparation / Handed off) and
 * the row/sidebar indicators.
 */
export function isHandedOff(item: Pick<TenderCaseListItemApi, "handedOffAt">): boolean {
  return item.handedOffAt != null
}
